export default __webpack_public_path__ + "static/media/Ð¡Ð½Ð¸Ð¼Ð¾Ðº ÑÐºÑÐ°Ð½Ð° 2024-06-27 124801.9cd10cb4.jpg";